module.exports = __webpack_public_path__ + "img/flag.b48f23aa.png";